import { render, staticRenderFns } from "./StatisticsCardIcon.vue?vue&type=template&id=f1ff447a"
import script from "./StatisticsCardIcon.vue?vue&type=script&lang=js"
export * from "./StatisticsCardIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports